/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Check_TitleInputs */

const en_how_we_work_check_title = /** @type {(inputs: How_We_Work_Check_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test the ordinary. And the exceptions.`)
};

const lv_how_we_work_check_title = /** @type {(inputs: How_We_Work_Check_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pārbaudām ierasto. Un izņēmumus.`)
};

/**
* | output |
* | --- |
* | "Test the ordinary. And the exceptions." |
*
* @param {How_We_Work_Check_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_check_title = /** @type {((inputs?: How_We_Work_Check_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Check_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_check_title(inputs)
	return en_how_we_work_check_title(inputs)
});